const DEFAULT_APP_CONFIG = {
    WEBUI_ENV_NAME: 'local',
    WEBUI_MFE_VERSIONS: {},
};
export const getApplicationConfig = () => {
    if (typeof window === 'undefined' || !window.__app_config) {
        return DEFAULT_APP_CONFIG;
    }
    return window.__app_config;
};
export const getMfeVersion = (mfe) => {
    const applicationConfig = getApplicationConfig();
    return applicationConfig?.WEBUI_MFE_VERSIONS[mfe];
};
export const setMfeVersion = (mfe, version) => {
    const applicationConfig = getApplicationConfig();
    if (!applicationConfig) {
        return;
    }
    applicationConfig.WEBUI_MFE_VERSIONS[mfe] = version;
};
